'use client';

import { c as _c } from "react/compiler-runtime";
import { ComponentPropsWithoutRef, ForwardedRef, ReactNode, createContext, forwardRef, use, useId } from 'react';
const IdContext = createContext<string | undefined>(undefined);
const useIdContext = () => {
  const id = use(IdContext);
  if (id === undefined) {
    throw new Error('useIdContext components must be used within a Fieldset');
  }
  return id;
};

/**
 * HTML fieldset and legend are very annoying to style.
 *
 * This is an accessible alternative with aria roles
 *
 * Use together with Legend
 */
export const LabeledContainer = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== children || $[1] !== id) {
    t1 = <IdContext.Provider value={id}>{children}</IdContext.Provider>;
    $[0] = children;
    $[1] = id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};

/**
 * Use together with Fieldset
 */
export const Input = forwardRef(function Input(props, ref) {
  const $ = _c(4);
  const id = useIdContext();
  let t0;
  if ($[0] !== id || $[1] !== props || $[2] !== ref) {
    t0 = <input {...props} id={id} ref={ref} />;
    $[0] = id;
    $[1] = props;
    $[2] = ref;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
});
export const Label = props => {
  const $ = _c(3);
  const id = useIdContext();
  let t0;
  if ($[0] !== id || $[1] !== props) {
    t0 = <label {...props} htmlFor={id} />;
    $[0] = id;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};